'use client'

import { buttonCls } from '@qr-front/ui/components/Button'
import { cn, getVersionForClone } from '@qr-front/ui/utils'

import { Link, usePathname } from '@/i18n-routing'

export const HeaderLinks = ({
	linkList,
}: {
	linkList: { url: string; label: string }[]
}) => {
	const currPathname = usePathname()

	return (
		<ul className="mr-2 flex gap-10">
			{linkList.map(({ url, label }) => {
				const isActive = currPathname === url

				return (
					<li key={url}>
						<Link
							href={url}
							className={cn(
								buttonCls({ visual: 'text' }),
								'px-0 font-normal',
								isActive && 'text-blue',
								getVersionForClone({
									base: 'type-body-medium',
									clone1: 'type-body-small',
								}),
							)}
						>
							{label}
						</Link>
					</li>
				)
			})}
		</ul>
	)
}
